module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (8).93817713.jpg";